import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__close",
  "use": "icon__close-usage",
  "viewBox": "0 0 23.813 23.906",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 23.813 23.906\" id=\"icon__close\"><path d=\"M13.305 11.946l10.216 10.255a.998.998 0 0 1 0 1.409.99.99 0 0 1-1.403 0L11.901 13.355 1.685 23.61a.99.99 0 0 1-1.403 0 .998.998 0 0 1 0-1.409l10.216-10.255L.282 1.692a.998.998 0 0 1 0-1.409.99.99 0 0 1 1.403 0l10.216 10.254L22.117.283a.99.99 0 0 1 1.404 0 1 1 0 0 1 0 1.409L13.305 11.946z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol